import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  Pa: { name: 'Pascal', factor: 1 },
  kPa: { name: 'Kilopascal', factor: 1000 },
  bar: { name: 'Bar', factor: 100000 },
  'psi': { name: 'Pound per Square Inch', factor: 6894.76 },
  'atm': { name: 'Atmosphere', factor: 101325 },
  'torr': { name: 'Torr', factor: 133.322 },
  'mmHg': { name: 'Millimeter of Mercury', factor: 133.322 },
  'inHg': { name: 'Inch of Mercury', factor: 3386.39 },
}

export default function PressureConverter() {
  const [fromUnit, setFromUnit] = useState('bar')
  const [toUnit, setToUnit] = useState('psi')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const pascals = value * fromFactor
    const result = pascals / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => setFromUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full mt-3"
                placeholder="Enter value"
                step="any"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => setToUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="text"
                value={toValue}
                readOnly
                className="input w-full mt-3 bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

